import { AxiosError } from 'axios';
import { QueryConfig, QueryResult, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import { loadFolderProperties } from '~src/services/api';
import { DbFolderProperties } from '~src/types/db';
import { useProjectId } from '../useProjectId';

interface UseFolderPropertiesParams {
  folderId: string;
}

export const useFolderProperties = (
  { folderId }: UseFolderPropertiesParams,
  queryConfig: QueryConfig<DbFolderProperties, AxiosError> & {
    enabled?: boolean;
  } = {}
): QueryResult<DbFolderProperties, AxiosError> => {
  const projectId = useProjectId();
  const { enabled, ...options } = queryConfig;
  const enabledOverwrite = enabled || enabled === undefined;

  const useFolderPropertiesQuery = useQuery<DbFolderProperties, AxiosError>(
    ['folderPermissions', { projectId: String(projectId), folderId }],
    loadFolderProperties,
    {
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return useFolderPropertiesQuery;
};
